import React from 'react'
import classes from './HeadingComponent.module.css'
import UniversityImage from '../../../Assests/Image/University.png'
import { Link } from 'react-router-dom'
const HeadingComponent = (props)=>{
   
    return(
        <div className={classes.container}>
            <div className={classes.headingContainer}>
             
    <p className={classes.universityText}>Welcome back {props.name}</p>
    {/* <p className={classes.trialText}>{props.trial_msg}</p> */}
    <p className={classes.trialText}>Your 1 day trial period has ended on 19th Feb, 2020. <Link to="/billing-page">Pay now</Link>  to continue reading.</p>
    <p className={classes.yearText}>{props.university}, {props.college}, {props.course}, {props.stream}, {props.year}, {props.semester}</p>
            </div>
            <div className={classes.universityImageContainer}>
            <img src={UniversityImage} className={classes.universtyImage} alt="University Image"/>
            </div>
        </div>
    )
}
export default HeadingComponent